import { useEffect, useState } from "react";

export default function useCompactFormTitle() {
  const [compact, setCompact] = useState(false);

  useEffect(() => {
    const container = document.getElementById("rootOutletContent");
    if (!container) return;

    const updateTitle = () => {
      setCompact((wasCompact) =>
        wasCompact ? container.scrollTop > 4 : container.scrollTop > 32,
      ); // separate thresholds prevent the title's height change from toggling it repeatedly
    };
    updateTitle();
    container.addEventListener("scroll", updateTitle, { passive: true });
    return () => container.removeEventListener("scroll", updateTitle);
  }, []);

  return compact;
}
